import { EpiLink } from '@api/types';
import { SmartLink } from '@components/common';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { ListItemText } from '@mui/material';
import { colors } from '@themes/colors';
import { isExternalLink } from '@utils/links.utils';
import { Fragment } from 'react';
import { useMultilevelMenuContext } from './MultilevelMenuProvider';
type MultilevelMenuLinksProps = {
  links?: EpiLink[];
};

export const MultilevelMenuLinks = ({ links }: MultilevelMenuLinksProps) => {
  const { handleCategoryEnter, shouldHighlight } = useMultilevelMenuContext();
  return (
    <Fragment>
      {links?.map((link, index) => (
        <div key={index} onMouseEnter={() => handleCategoryEnter(index.toString())}>
          <SmartLink
            {...link}
            sx={{
              '& .link-text': {
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                color: colors.text.primary,
                backgroundColor: shouldHighlight(index.toString())
                  ? colors.primary.lightGreen
                  : 'transparent',
                '&:hover': {
                  backgroundColor: colors.primary.lightGreen,
                },
              },
            }}
          >
            <ListItemText
              primary={link.text}
              sx={{
                px: 6,
                cursor: 'pointer',
                flex: 'none',
                minWidth: '250px',
              }}
            />
            {isExternalLink(link.href) ? <OpenInNewIcon sx={{ mr: 2 }} /> : null}
          </SmartLink>
        </div>
      ))}
    </Fragment>
  );
};
